"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Button = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var button_style_1 = require("./button-style");
var button_type_1 = require("./button-type");
function Button(props) {
    var _a = props.variant, variant = _a === void 0 ? button_type_1.ButtonVariant.PRIMARY : _a, _b = props.size, size = _b === void 0 ? button_type_1.ButtonSize.MEDIUM : _b, children = props.children, _c = props.className, className = _c === void 0 ? '' : _c, text = props.text, restProps = __rest(props, ["variant", "size", "children", "className", "text"]);
    return ((0, jsx_runtime_1.jsx)(button_style_1.StyledButton, __assign({}, restProps, { size: size, variant: variant, className: ['ripple', className].join(' '), children: children || text ? (0, jsx_runtime_1.jsx)(button_style_1.MiddleAlignedSpan, { size: size, children: children !== null && children !== void 0 ? children : text }) : null })));
}
exports.Button = Button;
